import { AxiosResponse } from "axios";
import { API_URL } from "../constants/url-config"
import { getAsync, patchAsync, putAsync } from "../utils/http-client";


const serviceUrl = API_URL.dashboardService

const API_PATH = {
    rapm: "/rapm/risk-adjusted-performance-measure",
    ermControlFailureFunctional: "/erm/control-failure-loss-database-functional",
    ermControlFailurEventType: "/erm/control-failure-loss-database-event-type",
    scenarios: "/erm/management-of-forward-looking-scenarios",
    ecapModule: "/ecap/require-available-capital"
}

const getRapmDataAsync = async (): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, API_PATH.rapm);
}

const getControlFailureLossDatabaseFunctionalAsync = async (): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, API_PATH.ermControlFailureFunctional);
}

const getControlFailureLossDatabaseEventTypeAsync = async (): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, API_PATH.ermControlFailurEventType);
}

const getScenariosDataAsync = async (): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, API_PATH.scenarios);
}

const getEcapModuleDataAsync = async (): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, API_PATH.ecapModule);
}

const refreshtEcapModuleDataAsync = async (): Promise<AxiosResponse> => {
    return await putAsync(serviceUrl, API_PATH.ecapModule);
}

const updateAvailableCapitalAsync = async (values: any): Promise<AxiosResponse> => {
    return await patchAsync(serviceUrl, API_PATH.ecapModule, values);
}

export const DashboardService = {
    getRapmDataAsync,
    getControlFailureLossDatabaseFunctionalAsync,
    getControlFailureLossDatabaseEventTypeAsync,
    getScenariosDataAsync,
    getEcapModuleDataAsync,
    refreshtEcapModuleDataAsync,
    updateAvailableCapitalAsync
}